import React from 'react';

function BottomCTA() {
  return (
    <section className="bottom-cta">
      <h3 className="bottom-cta-title">Boost your links today</h3>
      <button className="cta-button">Get Started</button>
    </section>
  )
}

export default BottomCTA;
